export const OPTIONS_BORDER_RADIUS = [
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' }
];

export const COLLAPSIBLE_BORDER_RADIUS = [
  { label: 'none', value: "none" },
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' }
];

export const PRODUCT_BORDER_RADIUS = [
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' },
  { label: 'Fully Rounded', value: '30px' }
];

export const PRODUCT_ALIGNMENT = [
  { label: 'Left', value: 'left' },
  { label: 'Right', value: 'right' },
  { label: 'Center', value: 'center' },
];

export const PRODUCT_WIDTH = [
  { label: 'Full Width', value: '100%' },
  { label: 'Content', value: 'max-content' },
];

export const OPTIONS_LAYOUT = [
  { label: 'Vertical Tiles', value: 'radio' },
  { label: 'Horizontal Tiles', value: 'horizontal' },
  { label: 'Tab', value: 'tab' },
  { label: 'Checkbox', value: 'checkbox' }
];

export const OPTIONS_DISCOUNT = [
  { label: 'Amount', value: 'price' },
  { label: 'Percentage', value: 'percent' },
  { label: 'Amount & Percentage', value: 'both' },
];

export const OPTIONS_PRODUCT_DESCRIPTION_SHAPE = [
  { label: 'Square', value: 'square' },
  { label: 'Rounded', value: 'rounded' }
];

export const IMAGE_SHAPE_OPTIONS = [
  { value: "rounded", label: "Rounded" },
  { value: "square", label: "Square" }
];

export const CAROUSEL_SHAPE_OPTIONS = [
  { value: "rounded", label: "Rounded" },
  { value: "square", label: "Square" }
];

export const NAV_SHAPE_OPTIONS = [
  { value: "rounded", label: "Rounded" },
  { value: "square", label: "Square" }
];

export const SLIDER_OPTIONS = [
  { value: "below", label: "Below" },
  { value: "left", label: "Left" }
];

export const METAFIELD_TYPE_OPTIONS = [
  { value: "tabs", label: "Tabs" },
  { value: "collapsible-list", label: "Collapsible List" }
];

export const COLOR_PICKER_STYLE_OPTIONS = [
  { value: "dropdown", label: "Dropdown Menu" },
  { value: "square", label: "Square Swatches" },
  { value: "circular", label: "Circular Swatches" },
  { value: "square_titles", label: "Square Swatches With Titles" },
  { value: "circular_titles", label: "Circular Swatches With Titles" },
  { value: "tiles", label: "Tiles" },
];

export const VARIANT_STYLE_OPTIONS = [
  { value: "dropdown", label: "Dropdown Menu" },
  { value: "btn_horizontal", label: "Button Horizontal" },
  { value: "btn_vertical", label: "Button Vertical" }
];

export const VARIANT_STYLE_OPTIONS_WITH_IMAGE = [
  { value: "dropdown", label: "Dropdown Menu" },
  { value: "btn_horizontal", label: "Button Horizontal" },
  { value: "btn_vertical", label: "Button Vertical" },
  { value: "img_tile", label: "Image Tile" }
];

export const IMG_TILE_POSITION_OPTIONS = [
  { value: "left", label: "Left" },
  { value: "right", label: "Right" },
  { value: "top", label: "Top" },
  { value: "img-only", label: "Image Only" }
];

export const IMG_ASPECT_RATIO_OPTIONS = [
  { value: "", label: "Default" },
  { value: "img-tile-ratio img-tile-ratio-1x1", label: "1x1" },
  { value: "img-tile-ratio img-tile-ratio-4x3", label: "4x3" },
  { value: "img-tile-ratio img-tile-ratio-16x9", label: "16x9" },
  { value: "img-tile-ratio img-tile-ratio-21x9", label: "21x9" }
];


export const SETTINGS_CONFIG = {
  // 1. BREADCRUMBS
  breadCrumbsOptions: {
    label: 'Breadcrumbs (Global)',
    id: 'breadCrumbsOptions',
    fields: [
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'breadCrumbs_border_style',
        options: OPTIONS_BORDER_RADIUS
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'breadCrumbs_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'breadCrumbs_background_color'
      },
      {
        type: 'colorPicker',
        title: 'Link color',
        key: 'breadCrumbs_link_color'
      },
      {
        type: 'colorPicker',
        title: 'Carrot color',
        key: 'breadCrumbs_carrot_color'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'breadCrumbs_text_color'
      },
      {
        type: 'dropdown',
        label: 'Width',
        key: 'breadCrumbs_width',
        options: PRODUCT_WIDTH
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'breadCrumbs_padding',
        min: 0,
        max: 35,
        step: 1
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 2. PRODUCT IMAGE & CAROUSEL
  productImage: {
    label: 'Product Image & Carousel',
    id: 'productImage',
    fields: [
      {
        type: 'toggle',
        id: 'autoplayToggle',
        title: 'Autoplay Carousel',
        key: 'autoplay_carousel_toggle',
        customHandler: 'handleAutoPlayCarouselToggle'
      },
      {
        type: 'dropdown',
        label: 'Product Image Shape',
        key: 'image_shape',
        options: IMAGE_SHAPE_OPTIONS,
        defaultValue: 'rounded'
      },
      {
        type: 'dropdown',
        label: 'Carousel Images Shape',
        key: 'carousel_shape',
        options: CAROUSEL_SHAPE_OPTIONS,
        defaultValue: 'rounded'
      },
      {
        type: 'dropdown',
        label: 'Icon Buttons Shape',
        key: 'image_nav_shape',
        options: NAV_SHAPE_OPTIONS,
        defaultValue: 'square'
      },
      {
        type: 'dropdown',
        label: 'Image Slider Position',
        key: 'slider_position',
        options: SLIDER_OPTIONS,
        defaultValue: 'below',
        customHandler: 'handleSliderPositionChange'
      },
      {
        type: 'colorPicker',
        title: 'Product Image Border Color',
        key: 'image_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Button Color',
        key: 'image_nav_button_color'
      },
      {
        type: 'colorPicker',
        title: 'Selected Image Border Color',
        key: 'image_selected_border_color'
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      },
    ]
  },

  // 3. PRODUCT PRICE
  Price: {
    label: 'Product Price',
    id: 'Price',
    fields: [
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'product_price_border_style',
        options: PRODUCT_BORDER_RADIUS
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'product_price_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Price color',
        key: 'product_price_color'
      },
      {
        type: 'colorPicker',
        title: 'Label color',
        key: 'product_price_label_color'
      },
      {
        type: 'colorPicker',
        title: 'Compare at Price color',
        key: 'product_compare_at_price_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'product_price_background_color'
      },
      {
        type: 'dropdown',
        label: 'Text Alignment',
        key: 'product_price_alignment',
        options: PRODUCT_ALIGNMENT
      },
      {
        type: 'dropdown',
        label: 'Width',
        key: 'product_price_width',
        options: PRODUCT_WIDTH
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'product_price_padding',
        min: 0,
        max: 50,
        step: 1
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 4. PRODUCT TITLE
  Title: {
    label: 'Product Title',
    id: 'Title',
    fields: [
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'product_title_border_style',
        options: PRODUCT_BORDER_RADIUS
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'product_title_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Title color',
        key: 'product_title_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'product_title_background_color'
      },
      {
        type: 'dropdown',
        label: 'Text Alignment',
        key: 'product_title_alignment',
        options: PRODUCT_ALIGNMENT
      },
      {
        type: 'dropdown',
        label: 'Width',
        key: 'product_title_width',
        options: PRODUCT_WIDTH
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'product_title_padding',
        min: 0,
        max: 50,
        step: 1
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 5. VARIANTS
  variants: {
    label: 'Variants',
    id: 'variants',
    fields: [
      {
        type: 'toggle',
        id: 'toggle_variant_tile_price',
        title: 'Display Prices On Variant',
        key: 'display_variant_tile_price',
        tooltip: 'Display prices on the last variant option when the variant type is set to "Button Vertical" and "Button Horizontal".'
      },
      {
        type: 'dropdown',
        label: 'Color Swatch Style',
        key: 'color_picker_style',
        options: COLOR_PICKER_STYLE_OPTIONS
      },
      {
        type: 'variantStyleDropdown',
        label: 'Variant 1 Style',
        key: 'variant1_style',
        variantNumber: 1
      },
      {
        type: 'variantStyleDropdown',
        label: 'Variant 2 Style',
        key: 'variant2_style',
        variantNumber: 2
      },
      {
        type: 'variantStyleDropdown',
        label: 'Variant 3 Style',
        key: 'variant3_style',
        variantNumber: 3
      },
      {
        type: 'section',
        title: 'Parent'
      },
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'variant_border_style',
        options: OPTIONS_BORDER_RADIUS
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'variant_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'variant_bg_color'
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'variant_padding',
        min: 0,
        max: 35,
        step: 1
      },
      {
        type: 'section',
        title: 'Variant Elements'
      },
      {
        type: 'colorPicker',
        title: 'Label Text color',
        key: 'variant_label_text_color'
      },
      {
        type: 'section',
        title: 'Button/Tile'
      },
      {
        type: 'colorPicker',
        title: 'Button/Tile color',
        key: 'variant_tile_color'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'variant_tile_text_color'
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'variant_tile_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Selected color',
        key: 'selected_tile_color'
      },
      {
        type: 'colorPicker',
        title: 'Selected Border color',
        key: 'selected_tile_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Price color',
        key: 'variant_price_color'
      },
      {
        type: 'colorPicker',
        title: 'Compare at price color',
        key: 'variant_compare_at_price_color'
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 6. CUSTOM MESSAGE
  customMessageOptions: {
    label: 'Custom Message Options',
    id: 'customMessageOptions',
    fields: [
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'custom_message_border_style',
        options: OPTIONS_BORDER_RADIUS
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'custom_message_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'custom_message_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'custom_message_background_color'
      },
      {
        type: 'dropdown',
        label: 'Text Alignment',
        key: 'custom_message_alignment',
        options: PRODUCT_ALIGNMENT,
        defaultValue: 'left'
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'custom_message_options_padding',
        min: 0,
        max: 35,
        step: 1
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 7. QUANTITY AND BUTTONS
  quantityAndButtonsOptions: {
    label: 'Quantity and Buttons',
    id: 'quantityAndButtonsOptions',
    fields: [
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'quantity_buttons_border_style',
        options: OPTIONS_BORDER_RADIUS
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'quantity_buttons_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'quantity_buttons_background_color'
      },
      {
        type: 'colorPicker',
        title: 'Add to Cart Button color',
        key: 'quantity_button_addToCart_btn_color'
      },
      {
        type: 'colorPicker',
        title: 'Add to Cart Text color',
        key: 'quantity_button_addToCart_text_color'
      },
      {
        type: 'colorPicker',
        title: 'Buy Now Button color',
        key: 'quantity_button_buyNow_btn_color'
      },
      {
        type: 'colorPicker',
        title: 'Buy Now Text color',
        key: 'quantity_button_buyNow_text_color'
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'quantity_buttons_padding',
        min: 0,
        max: 35,
        step: 1
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 8. SHARE PRODUCT
  shareProduct: {
    label: 'Share Product',
    id: 'shareProduct',
    fields: [
      {
        type: 'iconPicker',
        label: 'Share Icon',
        key: 'share_icon'
      },
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'share_border_style',
        options: OPTIONS_BORDER_RADIUS,
        defaultValue: '0px'
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'share_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'share_text_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'share_background_color'
      },
      {
        type: 'dropdown',
        label: 'Text Alignment',
        key: 'share_alignment',
        options: PRODUCT_ALIGNMENT,
        defaultValue: 'center'
      },
      {
        type: 'dropdown',
        label: 'Width',
        key: 'share_width',
        options: PRODUCT_WIDTH,
        defaultValue: 'max-content'
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'share_padding',
        min: 0,
        max: 50,
        step: 1
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 9. METAFIELDS
  metaFields: {
    label: 'Metafields',
    id: 'metaFields',
    fields: [
      {
        type: 'dropdown',
        label: 'Type',
        key: 'meta_field_type',
        options: METAFIELD_TYPE_OPTIONS
      },
      {
        type: 'conditional',
        condition: (data) => data.meta_field_type !== 'collapsible-list',
        fields: [
          {
            type: 'dropdown',
            label: 'Border Style',
            key: 'meta_field_border_style',
            options: OPTIONS_BORDER_RADIUS,
            defaultValue: '6px'
          },
          {
            type: 'colorPicker',
            title: 'Selected Tab Color',
            key: 'meta_field_selected_tab_color'
          }
        ]
      },
      {
        type: 'conditional',
        condition: (data) => data.meta_field_type === 'collapsible-list',
        fields: [
          {
            type: 'iconPicker',
            label: 'Open Icon',
            key: 'collapsible_list_open_icon',
            accordion: true
          },
          {
            type: 'iconPicker',
            label: 'Close Icon',
            key: 'collapsible_list_close_icon',
            accordion: true
          },
          {
            type: 'toggle',
            id: 'toggle_collapsible_list',
            title: 'Toggle List',
            key: 'collapsible_list_toggle'
          },
          {
            type: 'dropdown',
            label: 'Border Style',
            key: 'collapsible_list_border_style',
            options: COLLAPSIBLE_BORDER_RADIUS
          },
          {
            type: 'conditionalColorPicker',
            condition: (data) => data.collapsible_list_border_style !== 'none',
            title: 'Line color',
            key: 'collapsible_list_line_color'
          },
          {
            type: 'colorPicker',
            title: 'Icon color',
            key: 'collapsible_list_icon_color'
          }
        ]
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'meta_field_border_color'
      },
      {
        type: 'section',
        title: 'Header'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'meta_field_text_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'meta_field_bg_color'
      },
      {
        type: 'section',
        title: 'Body'
      },
      {
        type: 'colorPicker',
        title: 'Body Text color',
        key: 'meta_field_body_text_color'
      },
      {
        type: 'colorPicker',
        title: 'Body Background color',
        key: 'meta_field_body_bg_color'
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 10. SUBSCRIBE & SAVE
  subAndSave: {
    label: 'Subscribe & Save',
    id: 'subAndSave',
    fields: [
      {
        type: 'dropdown',
        label: 'Layout',
        key: 'layoutStyle',
        options: OPTIONS_LAYOUT
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'textColor'
      },
      {
        type: 'colorPicker',
        title: 'Selected Text Color',
        key: 'selectedTextColor'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'backgroundColor'
      },
      {
        type: 'colorPicker',
        title: 'Selected background color',
        key: 'selectedBackgroundColor'
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'borderColor'
      },
      {
        type: 'colorPicker',
        title: 'Selected border color',
        key: 'selectedBorderColor'
      },
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'borderStyle',
        options: OPTIONS_BORDER_RADIUS
      },
      {
        type: 'dropdown',
        label: 'Display options for savings',
        key: 'discountFormat',
        options: OPTIONS_DISCOUNT
      },
      {
        type: 'toggle',
        id: 'customIconToggle',
        title: 'Choose Custom Icon',
        key: 'useCustomIcon'
      },
      {
        type: 'conditional',
        condition: (data) => data.useCustomIcon,
        fields: [
          {
            type: 'iconPicker',
            label: 'One Time Icon',
            key: 'oneTimeIcon'
          },
          {
            type: 'iconPicker',
            label: 'Subscribe & Save Icon',
            key: 'subscribeIcon'
          }
        ]
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  },

  // 11. PRODUCT DESCRIPTION
  productDescription: {
    label: 'Description',
    id: 'productDescription',
    fields: [
      {
        type: 'section',
        title: 'General'
      },
      {
        type: 'dropdown',
        label: 'Shape',
        key: 'product_description_shape',
        options: OPTIONS_PRODUCT_DESCRIPTION_SHAPE,
        defaultValue: 'square'
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'product_description_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'product_description_background_color'
      },
      {
        type: 'section',
        title: 'Header'
      },
      {
        type: 'textInput',
        label: 'Title',
        key: 'product_description_header_text',
        defaultValue: 'Product Description'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'product_description_header_text_color'
      },
      {
        type: 'section',
        title: 'Body'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'product_description_body_text_color'
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
},
detail: {
  label: 'Detail',
  id: 'detail',
  fields: [
    {
      type: 'section',
      title: 'Details List'
    },
    {
      type: 'detailSelector',
      label: 'Select Detail',
      key: 'selected_detail'
    },
    {
      type: 'visibilityToggles',
      label: 'Visibility',
      key: 'visibility'
    }
  ]
}}